import { vsAuthApiInjected } from './vsAuthApiInjected';

const vsAuthApiEnhanced = vsAuthApiInjected;

export { vsAuthApiEnhanced as vsAuthApiSlice };
export * from './vsAuthApiInjected';
